<template>
  <div id="content">
    <MdPreview
      id="kungfutech"
      :model-value="modelValue"
      :theme="colorMode.value === 'dark' ? 'dark' : 'light'"
      :md-heading-id="mdHeadingId"
      language="en-US"
      :auto-fold-threshold="smallerThanLg ? 1 : 100"
      no-upload-img
      no-mermaid
      no-katex
      :style="{
        '--font-size': `${fontSize ?? settingsStore.getFontSize}px`,
        '--font-family': settingsStore.getFontFamily,
      }"
    />
    <ClientOnly>
      <Adsbygoogle
        v-if="isShowAds && !userStore.isUpgraded"
        ad-slot="1877896058"
        :ad-style="{ display: 'block', textAlign: 'center' }"
        ad-layout="in-article"
        ad-format="fluid"
      />
    </ClientOnly>
  </div>
</template>
<script setup lang="ts">
import { slugify } from "~/utils";
import { MdPreview } from "md-editor-v3";
import { useUserStore, useSettingsStore } from "~/store";
import "md-editor-v3/lib/preview.css";
import "~/assets/styles/content.css";
import { breakpointsTailwind } from "@vueuse/core";

const userStore = useUserStore();
const settingsStore = useSettingsStore();

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanLg = breakpoints.smaller("md");

interface EditorProps {
  isShowAds?: boolean;
  modelValue: string;
  fontSize?: number;
}

const colorMode = useColorMode();

withDefaults(defineProps<EditorProps>(), {
  isShowAds: false,
  modelValue: "",
  fontSize: undefined,
});

const mdHeadingId = (text) => {
  return slugify(text);
};
</script>
